var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"page"},[_c('div',{staticClass:"page__sidebar"},[_c('audit-side-bar')],1),_c('div',{staticClass:"page__main"},[_c('router-view',{ref:"mainContent",staticClass:"page__main-content"})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }